/** Диапазонное значение фильтра: числа, даты и время задаются границами */
export type FilterRange = { from?: unknown; to?: unknown };

export const isFilterRange = (value: unknown): value is FilterRange =>
  typeof value === 'object' &&
  value !== null &&
  !Array.isArray(value) &&
  !(value instanceof Date) &&
  ('from' in value || 'to' in value);

/** Граница диапазона не задана */
export const isEmptyBound = (bound: unknown): boolean => bound === undefined || bound === null || bound === '';

/** Фильтр есть в состоянии таблицы, но ничего не отбирает */
export const isEmptyFilterValue = (value: unknown): boolean => {
  if (isEmptyBound(value)) return true;
  if (Array.isArray(value)) return value.length === 0;
  if (isFilterRange(value)) return isEmptyBound(value.from) && isEmptyBound(value.to);
  return false;
};
